import Common_Shimmer from '@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer';
import React from 'react';
import GenericTable from '@frameworks/web/components/generic/GenericTable';
import { addDashIfNullOrUndefined } from '@domains/utils/numberMethods';
import GenericTooltip from '@frameworks/web/components/generic/GenericTooltip';
import { useDispatch, useSelector } from 'react-redux';
import di from '@di';
import { getDateInFormat } from '@domains/utils/reportDates';
import { threePaths } from "../DpInterest/DpInterestMobileTable";
export const newErrorIconpaths = Array(3)
    .fill('')
    .map((_, idx) => React.createElement("span", { key: idx, className: `path${idx + 1}` }));
const DpBillsTable = (props) => {
    var _a, _b, _c, _d;
    const { reducersData: dpBillsTableList, commonData: dpBillsCommonData } = useSelector((state) => state.DpBills.dpBillReport);
    const holdingSummary = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.holdingReport) === null || _a === void 0 ? void 0 : _a.dpTransactionLoader; });
    const totalObject = (_a = dpBillsTableList === null || dpBillsTableList === void 0 ? void 0 : dpBillsTableList.dpBillReport) === null || _a === void 0 ? void 0 : _a.find((item) => item.txnDate === 'Total');
    const dispatch = useDispatch();
    const dpBillsTableColumn = [
        {
            columnName: 'Txn Date',
            key: 'txnDate',
            columnClassName: 'RobotoM_14_500',
            applySorting: true,
            type: 'Date',
            arrows: true,
            onlyOneArrowAtaTime: true,
            tdCustomFunction: (key) => {
                return React.createElement("span", null, getDateInFormat(key, 'DD-MMM-YYYY'));
            }
        },
        {
            columnName: 'ISIN',
            key: 'isin',
            columnClassName: 'DMSanN_16_400',
            arrows: true,
            applySorting: true,
            onlyOneArrowAtaTime: true,
            type: 'string'
        },
        {
            columnName: 'Instrument',
            key: 'instrument',
            arrows: true,
            type: 'string',
            applySorting: true,
            onlyOneArrowAtaTime: true,
            tdCustomFunction: (key) => {
                return (React.createElement("div", { className: 'displayFlex' }, key === null || key === void 0 ? void 0 :
                    key.substring(0, 13),
                    key && key.length > 13 && (React.createElement("span", null,
                        React.createElement(GenericTooltip, { placement: 'top', toolTipText: key, triggerType: 'hover', button: React.createElement("span", { className: 'custom-ellipse txt_blackOne1' }, "..."), externalClassName: 'remove-btn-props', toolTipClassName: 'common-tooltip-custom-ellipse-notop' })))));
            },
            columnClassName: 'DMSans_16_500 w-17'
        },
        {
            columnName: 'Charges Details',
            key: 'chargesDetails',
            arrows: true,
            applySorting: true,
            type: 'string',
            onlyOneArrowAtaTime: true,
            tdCustomFunction: (key) => {
                return (React.createElement("div", { className: 'displayFlex' }, key === null || key === void 0 ? void 0 :
                    key.substring(0, 15),
                    key && key.length > 15 && (React.createElement("span", null,
                        React.createElement(GenericTooltip, { placement: 'top', toolTipText: key, triggerType: 'hover', button: React.createElement("span", { className: 'custom-ellipse txt_blackOne1' }, "..."), externalClassName: 'remove-btn-props', toolTipClassName: 'common-tooltip-custom-ellipse-notop' })))));
            },
            columnClassName: 'DMSans_16_500 w-17'
        },
        {
            columnName: 'Qty',
            key: 'qty',
            columnClassName: 'Roboto_16_400 taRight',
            applySorting: true,
            arrows: true,
            type: 'number',
            onlyOneArrowAtaTime: true,
            tdCustomFunction: addDashIfNullOrUndefined
        },
        {
            columnName: 'Charges(Rs)',
            key: 'charges',
            tdCustomFunction: (key) => {
                return addDashIfNullOrUndefined(key);
            },
            columnClassName: 'Roboto_16_400 taRight',
            applySorting: true,
            arrows: true,
            type: 'number',
            onlyOneArrowAtaTime: true
        },
        {
            columnName: 'Taxes (Rs)',
            key: 'taxes',
            applySorting: true,
            arrows: true,
            onlyOneArrowAtaTime: true,
            tdCustomFunction: (key) => {
                return addDashIfNullOrUndefined(key);
            },
            columnClassName: 'Roboto_16_400 taRight',
            type: 'number'
        },
        {
            columnName: 'Total Charges (Rs)',
            key: 'totalCharges',
            applySorting: true,
            arrows: true,
            onlyOneArrowAtaTime: true,
            tdCustomFunction: (key) => {
                return addDashIfNullOrUndefined(key);
            },
            columnClassName: 'Roboto_16_400 w-13 taRight',
            type: 'number'
        }
    ];
    React.useEffect(() => {
        dispatch(di.footer.updateShowMob_Menu(false));
        di.header.RemoveHeaderData(true);
    }, []);
    return (React.createElement("div", { className: 'dpbills-table' },
        React.createElement(GenericTable, { parentClassName: `right-aligned-arrow ${dpBillsCommonData.message.show && "dpbills-errormsg-noborder error-msg-new-icon"}`, loader: dpBillsCommonData.loader || holdingSummary, message: dpBillsCommonData.message, showMessage: dpBillsCommonData.message.show, customMsg: React.createElement("div", { className: 'DMSan_14_700 txt-midnight-blue' },
                "No results found!",
                React.createElement("div", { className: 'DMSanN_14_400 txt_secondary-gray' }, "Try searching for something else")), paths: threePaths, icon: dpBillsCommonData.message.icon, shimmer: React.createElement(Common_Shimmer, null), columns: dpBillsTableColumn, data: (_b = dpBillsTableList.dpBillReport) === null || _b === void 0 ? void 0 : _b.slice(0, ((_c = dpBillsTableList.dpBillReport) === null || _c === void 0 ? void 0 : _c.length) - 1), tableFooterData: ((_d = dpBillsTableList.dpBillReport) === null || _d === void 0 ? void 0 : _d.length) > 0 && (React.createElement("tr", null,
                React.createElement("td", { className: 'DMSan_14_700' }, "Total"),
                React.createElement("td", null),
                React.createElement("td", null),
                React.createElement("td", null),
                React.createElement("td", null),
                React.createElement("td", { className: 'Roboto_16_400 text-right' },
                    React.createElement("span", null, totalObject === null || totalObject === void 0 ? void 0 : totalObject.charges)),
                React.createElement("td", { className: 'Roboto_16_400 text-right' },
                    React.createElement("span", null, totalObject === null || totalObject === void 0 ? void 0 : totalObject.taxes)),
                React.createElement("td", { className: 'Roboto_16_400 text-right' },
                    React.createElement("span", null, totalObject === null || totalObject === void 0 ? void 0 : totalObject.totalCharges)))) })));
};
export default DpBillsTable;
